export default __webpack_public_path__ + "static/media/profile.cf67b67f.jpg";